'use strict';
var util = require('../util');

module.exports = {
  appVersion: '7.9.2',
  
  previewImage: util.actionMapping('previewImage')
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/dpapp/lib/patch/patch-7.9.2.js
// module id = 328
// module chunks = 1 12 14